// import { scan } from 'react-scan';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppWrapper, BrowserRouter } from '@shared/app';

// scan({
//   enabled: window.location.hostname === 'localhost',
// });

// OAuth (MCP): when Clerk routes its OAuth flow through this app, it loads us with a
// `redirect_url` pointing at Clerk's hosted Account Portal consent page. That hosted page 500s on
// our instance, so we host the consent ourselves: intercept the redirect here (before React/the
// auth-guard strips it) and send the user to our own /oauth/consent route, carrying the original
// OAuth params. Our consent page then completes the flow via the Clerk Frontend API directly.
(function interceptOAuthConsent() {
  try {
    const redirect = new URLSearchParams(window.location.search).get(
      'redirect_url'
    );
    if (!redirect) return;
    const url = new URL(redirect);
    const isClerkConsent =
      url.protocol === 'https:' &&
      (url.hostname === 'accounts.vrplatform.app' ||
        url.hostname === 'clerk.vrplatform.app') &&
      url.pathname.replace(/\/+$/, '') === '/oauth-consent';
    if (isClerkConsent) {
      // Re-render consent in our own app with the same OAuth params (client_id, scope,
      // redirect_uri, state, PKCE…), which live on the hosted-consent URL's query string.
      window.location.replace(`/oauth/consent${url.search}`);
    }
  } catch {
    // malformed redirect_url — let the app boot normally
  }
})();

const container = document.getElementById('root');

function App() {
  // Appwrapper needs to be outside to initialize sentry before creating "sentryCreateBrowserRouter" inside "BrowserRouter.tsx"
  return (
    <AppWrapper themePrimaryColor={'vrplatform'}>
      <BrowserRouter />
    </AppWrapper>
  );
}

function startApp() {
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <div className="App">
          <App />
        </div>
      </React.StrictMode>
    );
  }
}

startApp();
